import { styled } from 'styled-components';

import { Col, Container, Row } from 'react-bootstrap';

import { Typography } from '@vivaahealth/design-system';
import { EmbeddedFluidContainer } from '../Common';

import { useSelector } from 'react-redux';
import * as store from '../../../../reducers/store';

const Contact: React.FC = () => {
  const embedded = useSelector((store: store.All) => store.embedded);

  const content = (
    <>
      <hr className="my-0" color="var(--color-shade-40)" />
      <StyledRow>
        <Col xs={12} md={4} className="pb-4">
          <Typography variant="headline-small" bold>
            Need help?
          </Typography>
          <div className="mt-3">
            <Typography variant="paragraph-large">
              Our staff is happy to help you. If you need assistance, do not
              hesitate to contact us so that we can assist. For our full
              directory of services, visit our contact us page.
            </Typography>
          </div>
        </Col>
        <Col xs={12} md={4} className="pb-4">
          <Typography variant="headline-small" bold>
            Call us
          </Typography>
          <div className="mt-3">
            <Typography variant="paragraph-large">(888) 123-4560</Typography>
          </div>
          <div className="mt-2">
            <Typography variant="paragraph-large">
              M-F 8AM - 5PM (PST)
            </Typography>
          </div>
        </Col>
        <Col xs={12} md={4} className="pb-4">
          <div className="mb-3">
            <Typography variant="headline-small" bold>
              Email us
            </Typography>
          </div>
          <StyledEmailLink href="mailto: help@beaconhealthsystem.org">
            help@pcma.org
          </StyledEmailLink>
        </Col>
      </StyledRow>
    </>
  );
  return embedded ? (
    <EmbeddedFluidContainer fluid className="mb-4 mt-5">
      {content}
      <StyledHr className="mt-1" />
    </EmbeddedFluidContainer>
  ) : (
    <>
      <LimitedContainer className="mb-4 mt-5">{content}</LimitedContainer>
    </>
  );
};
export default Contact;

const StyledEmailLink = styled.a`
  color: var(--color-primary);
  font-size: 18px;
  font-weight: 600;
`;

const LimitedContainer = styled(Container)`
  @media (min-width: 1200px) {
    max-width: 1032px;
  }
`;

const StyledHr = styled.hr`
  margin-bottom: 40px;
`;

const StyledRow = styled(Row)`
  margin-top: 40px;
`;
